import { render, staticRenderFns } from "./exce-mb.vue?vue&type=template&id=26827bde&scoped=true&"
import script from "./exce-mb.vue?vue&type=script&lang=js&"
export * from "./exce-mb.vue?vue&type=script&lang=js&"
import style0 from "./exce-mb.vue?vue&type=style&index=0&id=26827bde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26827bde",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
